<template>
    <div id="schoolSignupNoticeList">
        <div class="second-header-wrap">
            <el-select v-model="currentNotice" @change="noticeChange" placeholder="请选择">
                <el-option
                    v-for="noticeItem in noticeList"
                    :key="noticeItem.id"
                    :label="noticeItem.title"
                    :value="noticeItem.id">
                </el-option>
            </el-select>
            <school-year-selector @change="getVoteTwoRecruitNoticeListFunc"></school-year-selector>
            <el-input style="width: 200px;" v-model.trim="searchTitle" v-if="currentNotice" size="medium"
                      @keyup.native.enter="getVoteTwoRecruitUserListFunc" @blur="getVoteTwoRecruitUserListFunc"
                      placeholder="请输入身份证号或姓名"></el-input>
            <template v-if="isSelectedYearCurrent && currentNotice">
<!--                <el-button type="primary" @click="batchDelete" size="medium">批量删除</el-button>-->
                <el-button type="primary" @click="batchSignup" size="medium">批量预录取</el-button>
                <el-button type="primary" @click="sendMessageClick" size="medium">发送短信</el-button>
                <el-button type="primary" @click="jumpNo" size="medium">跳号</el-button>
            </template>

            <a :href="exportURL" download="导出" target="_blank" v-if="currentNotice">
                <el-button class="filter-item" type="primary" icon="upload" size="medium">导出</el-button>
            </a>
        </div>
        <div class="table-container">
            <el-table
                ref="messageTable"
                :data="dataList"
                class="messageTable custom—scrollbar"
                fit
                style="width: 100%"
                border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection" align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="报名编号" align="center" prop="recruitNo">
                </el-table-column>
                <el-table-column
                    label="姓名" align="center" show-overflow-tooltip width="300">
                    <template slot-scope="scope">
                        <router-link
                            :to="{path: 'signupDetail', query: {gender: scope.row.gender === 1 ? '男' : '女', cardId: scope.row.cardId, voteId: scope.row.voteId, noticeId: currentNotice, userName: scope.row.userName, mobile: scope.row.mobile, birthday: scope.row.birthDate, recruitNo: scope.row.recruitNo}}">
                            {{scope.row.userName}}
                            <span v-if="scope.row.elseCount > 0">&nbsp;&nbsp;<i class="el-icon-key"></i></span>
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column
                    label="性别" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.gender === 1 ? '男' : '女'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="身份证/护照号" align="center">
                    <template slot-scope="scope">
                        <span class="link-type" @click="showStuSchool(scope.row)" v-if="scope.row.schoolName">{{scope.row.cardId|setCertNo}}</span>
                        <span v-else>{{scope.row.cardId|setCertNo}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="家长手机号" align="center" prop="mobile">
                </el-table-column>
                <el-table-column
                    label="报名时间" align="center">
                    <template slot-scope="scope">
                        {{scope.row.createTime | timeSuffixFilter}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="状态" align="center" prop="state">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.recruitStatus == 3" type="success" >录取中</el-tag>
                        <template v-else>
                            <el-tag v-if="scope.row.batchState == 1" type="danger">未录取</el-tag>
                            <el-tag v-else>报名成功</el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作" align="center" prop="state" v-if="isSelectedYearCurrent">
                    <template slot-scope="scope">
                       <el-button v-if="isShowByPermission('/voteTwo/delVoteTwoRecruitUser')" :disabled="scope.row.recruitStatus !== 2" size="small" type="text"
                                  @click.native="deleteUser(scope.row)">
                           删除
                       </el-button>
                        <el-button :disabled="scope.row.recruitStatus === 3" size="small" type="text"
                                   @click.native="signup(scope.row)">
                            预录取
                        </el-button>
                        <el-button :disabled="scope.row.recruitStatus === 3 || scope.row.batchState == 1" size="small" type="text"
                                   @click.native="signupNot(scope.row)">
                            未录取
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog :close-on-click-modal='false' title="短信" :visible.sync="dialogVisible" width="60%">
            <div>
                <el-form :model="singleData" label-width="120px" :rules="singleRules" ref="single">
                    <el-form-item label="短信模板" prop="smsTempId">
                        <el-select @change="getTemp" v-model="singleData.smsTempId" placeholder="请选择">
                            <el-option :key="tempItem.id" v-for="tempItem in templateList" :label="tempItem.title"
                                       :value="tempItem.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模板" prop="temp">
                        <template v-for="(segment, index) in tempSegments">
                            <span v-if="segment.type === 'text'" :key="index + 1" v-html="segment.value"></span>
                            <el-input :key="index + 2"
                                style="width: 120px; margin: 0 4px;" 
                                v-else 
                                v-model="tempVars[segment.varName]"
                                :placeholder="'请输入' + segment.varName"
                                size="small"
                            ></el-input>
                        </template>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="determineHandler()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="报名学校" :visible.sync="isShowStuSchool" size="tiny" width="400px">
            <div>
                <div class="school-list">
                    <div class="school-item"
                         v-for="(schoolName, index) in stuSchoolList"
                    >
                        <div class="school-item__text">
                            {{schoolName}}
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal='false' title="跳号" :visible.sync="isShowJumpNoDialog" size="tiny" width="400px">
            <div>
                <el-form :model="jumpNoFormData" label-width="120px" :rules="jumpNoFormRules" ref="jumpNoForm">
                    <el-form-item label="跳号" prop="numCount">
                        <el-input-number v-model="jumpNoFormData.numCount" :step="1" :min="1" step-strictly
                                         :max="10000">
                        </el-input-number>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowJumpNoDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="jumpNoConfirm()">确 定</el-button>
            </span>
        </el-dialog>

        <div class="pagination-container">
            <el-pagination
                @size-change="sizeChangeHandler"
                @current-change="currentChangeHandler"
                :current-page.sync="pagination.pageNo"
                :page-sizes="[10 , 20, 30, 50, 100]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :page-count="pagination.pages"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import SchoolYearSelector from '@/components/SchoolYearSelector';
    import {
        addStudentAndParent,
        getVoteTwoRecruitNoticeList,
        getVoteTwoRecruitUserList,
        updateVoteTwoRecruitUser,
        queryTemplateBySchoolId,
        sendSMS,
        delVoteTwoRecruitUser,
        jumpRecruitNoticeNum
    } from '@/api/notice';
    import baseMixin from '@/mixins/baseMixin';
    import {mapGetters} from 'vuex';
    import {isShowByPermission} from '@/utils/utils';
    export default {
        name: "SignupList",
        data: function () {
            const tempValidator = (rule, value, callback) => {
                const hasEmptyVar = Object.values(this.tempVars).some(val => val === '');
                if (hasEmptyVar) {
                    callback(new Error('请正确填写模板变量！'));
                } else {
                    callback();
                }
            };
            return {
                dataList: [],
                noticeList: [],
                currentNotice: null,
                voteId: null,
                searchTitle: '',
                selection: [],
                dialogVisible: false,
                listQuery: {
                    mobiles: "",
                    moduleCode: "20190308",
                    moduleName: "招生登记幼儿园版本",
                    smsContent: "",
                    schoolYear:'',
                    templateName: '',
                    templateCode: '',
                    templateParamJson: ''
                },
                singleData: {
                    smsTempId: ''
                },
                temp: [],
                tempAnswer: [],
                templateList: [],
                singleRules: {
                    smsTempId: [{
                        required: true, message: '模板不能为空', trigger: 'blur'
                    }],
                    temp: [{
                        required: true, trigger: 'blur', validator: tempValidator
                    }],
                },
                isShowStuSchool: false,
                stuSchoolList: [],

                isShowJumpNoDialog: false,
                jumpNoFormData: {
                    numCount: 1
                },
                jumpNoFormRules: {
                    numCount: [{
                        required: true, message: '请输入跳号', trigger: 'blur'
                    }],
                },
                tempSegments: [],
                tempVars: {},
            }
        },
        components: {SchoolYearSelector},
        computed: {
            ...mapGetters(['userInfo', 'isSelectedYearCurrent']),
            exportURL: function () {
                const baseHref = global.command === 'production' ? 'https://www.zhxiaoyuan.cn/module-web/' : 'https://www.weixiaojia.net/module-web/';
                return `${baseHref}structure/voteTwo/exportVoteTwoRecruitUserListAll?noticeId=${this.currentNotice}&schoolYear=${this.$store.getters.selectedSchoolYear}&voteId=${this.voteId}&token=${this.$store.getters.token}`;
            }
        },
        created() {
            this.getVoteTwoRecruitNoticeListFunc();

            queryTemplateBySchoolId()
                .then(res => res.data)
                .then(data => {
                    this.templateList = data.data.filter(item => item.statusCode == 0);
                    if (this.templateList.length) {
                        this.singleData.smsTempId = this.templateList[0].id;
                        this.getTemp()
                    }
                });
        },
        mixins: [baseMixin],
        filters:{
            setCertNo(certNo) {
                    if (certNo && certNo.length >= 10) {
                        let cert1 = certNo.substring(0, 6) + '**' + certNo.substring(8, certNo.length - 4) + '****';
                        return cert1;
                    }else{
                        return certNo;
                    }
                },
        },
        methods: {
            isShowByPermission,
            getVoteTwoRecruitNoticeListFunc() {
                this.searchTitle = '';
                getVoteTwoRecruitNoticeList()
                    .then(res => res.data)
                    .then(data => {
                        const noticeList = data.data.filter(({status}) => status === 2);
                        this.noticeList = noticeList;
                        if (noticeList.length !== 0) {
                            this.currentNotice = noticeList[0].id;
                            this.voteId = noticeList[0].voteId;
                            this.getVoteTwoRecruitUserListFunc();
                        } else {
                            this.currentNotice = null;
                            this.voteId = null;
                            this.dataList = [];
                            this.pagination.total = 0;
                        }
                    });
            },
            jumpNo() {
                this.jumpNoFormData = {
                    numCount: 1
                };
                this.isShowJumpNoDialog = true;
            },
            jumpNoConfirm() {
                this.$refs.jumpNoForm.validate(isValid => {
                    if(isValid) {
                        jumpRecruitNoticeNum({
                            noticeId: this.currentNotice,
                            numCount: this.jumpNoFormData.numCount
                        })
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message.success('跳号设置成功');
                                    this.isShowJumpNoDialog = false;
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    }
                });
            },
            showStuSchool(item) {
                this.isShowStuSchool = true;
                this.stuSchoolList = item.schoolName.split(',');
            },
            sizeChangeHandler(pageSize) {
                this.pagination.pageSize = pageSize;
                this.pagination.pageNo = 1;
                this.getVoteTwoRecruitUserListFunc();
            },
            currentChangeHandler(pageNo) {
                this.pagination.pageNo = pageNo;
                this.getVoteTwoRecruitUserListFunc();
            },
            noticeChange() {
                this.voteId = this.noticeList.find(({id}) => id === this.currentNotice).voteId;
                console.log(this.voteId);
                this.getVoteTwoRecruitUserListFunc();
            },
            getVoteTwoRecruitUserListFunc() {
                getVoteTwoRecruitUserList({
                    noticeId: this.currentNotice,
                    searchTitle: this.searchTitle,
                    pageSize: this.pagination.pageSize,
                    pageNo: this.pagination.pageNo
                })
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.pagination.total = data.data.pagination.total;
                    })
            },
            // 删除用户
            deleteUser({id, noticeId, voteId}) {
                this.$confirm('是否删除该学生?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delVoteTwoRecruitUser([{
                        id,
                        noticeId,
                        voteId
                    }])
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message({
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getVoteTwoRecruitUserListFunc();
                            }
                        })
                });

            },
            // 批量删除
            batchDelete() {

                if (this.selection && this.selection.length !== 0) {
                    this.$confirm('是否删除选中的学生?', '删除', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        const voteTwoRecruitUserList = this.selection.map(({voteId, id, noticeId}) => ({
                            voteId, id, noticeId
                        }));
                        delVoteTwoRecruitUser(voteTwoRecruitUserList)
                            .then(res => res.data)
                            .then(data => {
                                if (data.result) {
                                    this.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.getVoteTwoRecruitUserListFunc();
                                }
                            });
                    });
                } else {
                    this.$message.error('请选择学生');
                }
            },
            signup(studentInfo) {
                this.$confirm('是否录取?', '录取', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const args = {
                        gender: studentInfo.gender,
                        learnNum: `${this.currentNotice}${studentInfo.recruitNo}`,
                        name: studentInfo.userName,
                        cardId: studentInfo.cardId,
                        cardType: studentInfo.cardType,
                        recruitUserIds: studentInfo.id,
                        schoolYear:this.$store.getters.selectedSchoolYear,
                        relatives: [{
                            gender: 0,
                            nick: `家长`,
                            mobile: studentInfo.mobile
                        }]
                    };
                    addStudentAndParent(args)
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.$message({
                                    message: '录取成功',
                                    type: 'success'
                                });
                                const arg = [{
                                    cardId: studentInfo.cardId,
                                    mobile: studentInfo.mobile,
                                    noticeId: this.currentNotice,
                                    recruitStatus: 3
                                }];
                                 this.getVoteTwoRecruitUserListFunc();
                                // updateVoteTwoRecruitUser(arg)
                                //     .then(res => res.data)
                                //     .then(data => {
                                //         if (data.result) {
                                //             this.getVoteTwoRecruitUserListFunc();
                                //         }
                                //     });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                }).catch(() => {
                });
            },
            signupNot(studentInfo) {
                this.$confirm('是否标记为未录取?', '未录取', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const arg = [{
                        // cardId: studentInfo.cardId,
                        // noticeId: this.currentNotice,
                        batchState: 1,
                        id: studentInfo.id,
                    }];
                    
                    updateVoteTwoRecruitUser(arg)
                        .then(res => res.data)
                        .then(data => {
                            if (data.result) {
                                this.getVoteTwoRecruitUserListFunc();
                            }
                        });
                }).catch(() => {
                });
            },
            sendMessageClick() {
                if (this.selection && this.selection.length !== 0) {
                    this.singleData.smsTempId = this.templateList.length
                        ? this.templateList[0].id
                        : ''
                    this.getTemp()
                    this.dialogVisible = true;
                } else {
                    this.$message.error('请选择学生');
                }
            },
            batchSignup() {
                if (this.selection && this.selection.length !== 0) {
                    this.$confirm('是否录取?', '录取', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        const batchArray = [], signed = [];
                        let count = 0;
                        this.selection.forEach(stuItem => {
                            const _this = this;
                            if (stuItem.recruitStatus === 2) {

                                batchArray.push(
                                    new Promise((resolve, reject) => {
                                        const args = {
                                            gender: stuItem.gender,
                                            learnNum: `${this.currentNotice}${stuItem.recruitNo}`,
                                            name: stuItem.userName,
                                            cardId: stuItem.cardId,
                                            cardType: stuItem.cardType,
                                            recruitUserIds:stuItem.id,
                                            schoolYear:this.$store.getters.selectedSchoolYear,
                                            relatives: [{
                                                gender: 0,
                                                nick: `家长`,
                                                mobile: stuItem.mobile
                                            }]
                                        };
                                        addStudentAndParent(args)
                                            .then(res => res.data)
                                            .then(data => {
                                                if (data.result) {
                                                    this.$message({
                                                        message: `${args.name}录取成功`,
                                                        type: 'success'
                                                    });
                                                    signed.push({
                                                        cardId: stuItem.cardId,
                                                        mobile: stuItem.mobile,
                                                        noticeId: this.currentNotice,
                                                        recruitStatus: 3
                                                    });
                                                    resolve();
                                                } else {
                                                    this.$message.error(data.msg);
                                                    resolve();
                                                }
                                            })
                                    })
                                );
                            }
                        });
                        if (batchArray.length !== 0) {
                            Promise.all(batchArray)
                                .then(() => {
                                    this.getVoteTwoRecruitUserListFunc();
                                    // updateVoteTwoRecruitUser(signed)
                                    //     .then(res => res.data)
                                    //     .then(data => {
                                    //         if (data.result) {
                                                
                                    //         }
                                    //     });
                                })
                                .catch(error => {
                                    this.$message.error(error)
                                })
                        }


                    });
                } else {
                    this.$message.error('请选择学生');
                }
            },
            handleSelectionChange(selection) {
                this.selection = selection;
            },
            getTemp() {
                let id = this.singleData.smsTempId;
                const template = this.templateList.find(item => item.id === id);
                this.listQuery.templateCode = template.templateId;
                if (template) {
                    const regex = /\$\{([^}]+)\}/g;
                    const segments = [];
                    let lastIndex = 0;
                    let match;
                    const varNames = new Set();
                    
                    while ((match = regex.exec(template.content)) !== null) {
                        if (match.index > lastIndex) {
                            segments.push({
                                type: 'text',
                                value: template.content.slice(lastIndex, match.index)
                            });
                        }
                        const varName = match[1];
                        varNames.add(varName);
                        segments.push({
                            type: 'var',
                            varName: varName
                        });
                        lastIndex = match.index + match[0].length;
                    }
                    
                    if (lastIndex < template.content.length) {
                        segments.push({
                            type: 'text',
                            value: template.content.slice(lastIndex)
                        });
                    }
                    
                    this.tempSegments = segments;
                    
                    this.tempVars = {};
                    varNames.forEach(name => {
                        this.$set(this.tempVars, name, '');
                    });
                }
            },
            buildSmsContent(templateContent) {
                if (!templateContent) return '';
                const regex = /\$\{([^}]+)\}/g;
                return templateContent.replace(regex, (match, varName) => {
                    return this.tempVars[varName] || '';
                });
            },
            //确定
            determineHandler() {
                this.$refs.single.validate((valid) => {
                    if (valid) {
                        this.dialogVisible = false;
                        const template = this.templateList.find(item => item.id === this.singleData.smsTempId);
                        this.listQuery.schoolYear=this.$store.getters.selectedSchoolYear;                        
                        this.listQuery.mobiles = this.selection.map(item => item.id).join(',');
                        this.listQuery.templateName = template.title
                        this.listQuery.smsContent = this.buildSmsContent(template ? template.content : '');
                        this.listQuery.templateParamJson = JSON.stringify(this.tempVars)

                        sendSMS(this.listQuery)
                            .then(res => res.data)
                            .then(data => {
                                if (data.result) {
                                    this.$message({
                                        message: '已发送短信',
                                        type: 'success'
                                    });
                                }
                            });
                    }
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin.scss";

    .table-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
    }

    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }

    .main-wrap {
        width: 100%;
        margin-top: 229px;
    }

    .main-container {
        width: 1320px;
        padding: 30px 10px;
        margin: 0 auto;
        min-height: 560px;
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .pagination-container {
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
        z-index: 1000;
    }
    .school-list {
        height: 368px;
        padding: 0 20px;
        overflow-y: auto;
    }


    .school-item {
        box-sizing: border-box;
        width: 100%;
        padding: 5px 20px;
        box-shadow: #ccc 0 0 5px;
        margin: 12px 0;
        border-radius: 6px;
        border: 1px solid #fff;
    }


    .school-item__subtext {
        color: #ACACAC;
    }

    .footer {
        border-top: 1px solid #EEEEEE;
        padding: 10px 20px;
    }
</style>
<style>
    #schoolSignupNoticeList a {
        color: #409EFF;
        text-decoration: none;
    }
</style>




// WEBPACK FOOTER //
// src/views/kindergarten/signup/SignupList.vue